import React from 'react';
import classes from './index.module.scss';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const Title = ({ title, hasIcon = true, icon, color = '#516187' }: any) => {
  return (
    <div className={classes.container}>
      <span className={classes.icon}>
        {hasIcon && (icon ?? <CheckCircleOutlineIcon sx={{ color: '#0F7D8F', fontSize: '30px' }} />)}
      </span>
      <span className={classes.title} style={{ color }}>
        {title}
      </span>
    </div>
  );
};
export default Title;
